import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Setup globale: osserva il document.body per qualunque `.reveal` (anche aggiunto
 * dinamicamente dopo route change) e gli applica `.is-visible` quando entra nel viewport.
 * Si rimonta a ogni cambio rotta per ri-osservare gli elementi della nuova pagina.
 */
export default function GlobalRevealObserver() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (typeof IntersectionObserver === "undefined") return;
    let observer = null;
    const observeAll = () => {
      const targets = document.querySelectorAll(".reveal:not(.is-visible)");
      targets.forEach((el) => observer && observer.observe(el));
    };
    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.05 });

    // Osserva subito + poi continuamente per elementi aggiunti dopo (es. lazy data)
    observeAll();
    const mutation = new MutationObserver(() => observeAll());
    mutation.observe(document.body, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
      mutation.disconnect();
    };
  }, [pathname]);

  return null;
}
